export const LIST_GEOGRAPHIC_LOCATIONS = 'LIST_GEOGRAPHIC_LOCATIONS';
